import MessageTemplates from './MessageTemplates';

export default MessageTemplates;
